import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const holidayManagementApiKeyStore = {
  createHoliday: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_HOLIDAY`],
    route: `/Holiday`,
    action: 'POST',
  }),
  updateHoliday: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_HOLIDAY`],
    route: `/Holiday`,
    action: 'PUT',
  }),
  deleteHoliday: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_HOLIDAY`, id],
    route: `/Holiday/${id}`,
    action: 'DELETE',
  }),
  getHolidays: (): QueryKeyConfig => ({
    queryKey: [`GET_HOLIDAYS`],
    route: `/Holiday`,
  }),
};
